/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseRoleDto } from '../models/BaseRoleDto';
import type { GetBaseRolesResponseAdmin } from '../models/GetBaseRolesResponseAdmin';
import type { PutBaseRoleRequestAdmin } from '../models/PutBaseRoleRequestAdmin';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BaseRolesService {
    /**
     * **Required Policy:** `ViewBaseRoles`
     * @returns BaseRoleDto OK
     * @throws ApiError
     */
    public static getBaseRoleAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<BaseRoleDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/baseroles/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageBaseRoles`
     * @returns BaseRoleDto OK
     * @throws ApiError
     */
    public static putBaseRoleAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutBaseRoleRequestAdmin,
    }): CancelablePromise<BaseRoleDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/baseroles/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewBaseRoles`
     * @returns GetBaseRolesResponseAdmin OK
     * @throws ApiError
     */
    public static getBaseRolesAdmin(): CancelablePromise<GetBaseRolesResponseAdmin> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/baseroles',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
